(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dr-demo"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-dr-demo]').forEach((section) => {
      if (section.dataset.drDemoReady === 'true') return;
      section.dataset.drDemoReady = 'true';

      const tabs = Array.from(section.querySelectorAll('[role="tab"]'));
      const panels = Array.from(section.querySelectorAll('[role="tabpanel"]'));

      const activate = (tab, focus = false) => {
        const target = tab.dataset.drTab;

        tabs.forEach((item) => {
          const isActive = item === tab;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-selected', String(isActive));
          item.tabIndex = isActive ? 0 : -1;
        });

        panels.forEach((panel) => {
          const isActive = panel.dataset.drPanel === target;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });

        if (focus) tab.focus();
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();

          let nextIndex = index;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          activate(tabs[nextIndex], true);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dr-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-dr-hero]').forEach((hero) => {
      const sticky = hero.querySelector('[data-dr-sticky]');
      if (!sticky || !('IntersectionObserver' in window)) return;

      const offer = document.querySelector('#dr-offer');
      let heroVisible = true;
      let offerVisible = false;

      const update = () => {
        sticky.hidden = heroVisible || offerVisible;
      };

      const heroObserver = new IntersectionObserver((entries) => {
        heroVisible = entries[0].isIntersecting;
        update();
      }, { threshold: 0.08 });

      heroObserver.observe(hero);

      if (offer) {
        const offerObserver = new IntersectionObserver((entries) => {
          offerVisible = entries[0].isIntersecting;
          update();
        }, { threshold: 0.05 });

        offerObserver.observe(offer);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    event.preventDefault();
  });

  function readProductSettingsJSON(root) {
    if (!root) return null;
    const scripts = root.querySelectorAll('script[type="application/json"]');
    for (const s of scripts) {
      for (const attr of Array.from(s.attributes)) {
        if (attr.name.startsWith('data-product-settings-')) {
          return JSON.parse(s.textContent || '{}');
        }
      }
    }
    return null;
  }

  document.addEventListener('product-form:message:success', (event) => {
    const sectionEl = event.detail.form.closest('.shopify-section');
    const settings = readProductSettingsJSON(sectionEl) || {};
    if (settings && typeof settings.successMessage === 'string') {
      const title = event.detail.response?.title ?? event.detail.response?.product_title ?? '';
      event.detail.message = settings.successMessage.replace('** product **', title);
    }

    console.log(event.detail);

    if (event.detail.cart && typeof event.detail.cart.item_count === 'number') {
      document.dispatchEvent(new CustomEvent('cart:count', { detail: { count: event.detail.cart.item_count } }));
    }
  });

  function initializeLaborDayCountdown(root = document) {
    const countdowns = root.querySelectorAll('[data-labor-day-countdown]:not([data-countdown-ready])');

    countdowns.forEach((countdown) => {
      countdown.dataset.countdownReady = 'true';
      const endAt = Date.parse(countdown.dataset.saleEnds || '');
      const hours = countdown.querySelector('[data-countdown-hours]');
      const minutes = countdown.querySelector('[data-countdown-minutes]');
      const seconds = countdown.querySelector('[data-countdown-seconds]');

      if (!Number.isFinite(endAt) || !hours || !minutes || !seconds) {
        countdown.hidden = true;
        return;
      }

      let intervalId;

      const updateCountdown = () => {
        const remaining = endAt - Date.now();

        if (remaining <= 0) {
          countdown.hidden = true;
          window.clearInterval(intervalId);
          return;
        }

        const totalSeconds = Math.floor(remaining / 1000);
        hours.textContent = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
        minutes.textContent = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
        seconds.textContent = String(totalSeconds % 60).padStart(2, '0');
      };

      updateCountdown();
      intervalId = window.setInterval(updateCountdown, 1000);
    });
  }

  initializeLaborDayCountdown();
  document.addEventListener('shopify:section:load', (event) => {
    initializeLaborDayCountdown(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutrition-calculator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roundTo = (value, step) => Math.round(value / step) * step;
    const format = (template, values) => Object.keys(values).reduce(
      (output, key) => output.replaceAll(`{${key}}`, values[key]),
      template
    );

    const createElement = (tag, className, text) => {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (text !== undefined) element.textContent = text;
      return element;
    };

    const ingredient = (id, amount, unit, scale, category) => ({
      id,
      amount,
      unit,
      scale,
      category
    });

    const mealTemplates = {
      omnivore: [
        {
          id: 'breakfast',
          ingredients: [
            ingredient('oats', 90, 'g', 'carb', 'carbs'),
            ingredient('bananas', 1, 'count', 'carb', 'carbs'),
            ingredient('greek_yogurt', 170, 'g', 'protein', 'protein'),
            ingredient('peanut_butter', 1.5, 'tbsp', 'fat', 'fats')
          ]
        },
        {
          id: 'snack',
          ingredients: [
            ingredient('bagels', 1, 'count', 'carb', 'carbs'),
            ingredient('jam', 2, 'tbsp', 'carb', 'carbs'),
            ingredient('greek_yogurt', 150, 'g', 'protein', 'protein'),
            ingredient('peanut_butter', 1, 'tbsp', 'fat', 'fats')
          ]
        },
        {
          id: 'lunch',
          ingredients: [
            ingredient('rice', 130, 'g', 'carb', 'carbs'),
            ingredient('vegetables', 150, 'g', 'carb', 'carbs'),
            ingredient('chicken', 120, 'g', 'protein', 'protein'),
            ingredient('olive_oil', 1, 'tbsp', 'fat', 'fats')
          ]
        },
        {
          id: 'pre_training',
          ingredients: [
            ingredient('white_bread', 4, 'slice', 'carb', 'carbs'),
            ingredient('bananas', 1, 'count', 'carb', 'carbs'),
            ingredient('jam', 2, 'tbsp', 'carb', 'carbs'),
            ingredient('greek_yogurt', 100, 'g', 'protein', 'protein')
          ]
        },
        {
          id: 'dinner',
          ingredients: [
            ingredient('pasta', 120, 'g', 'carb', 'carbs'),
            ingredient('marinara', 200, 'g', 'carb', 'carbs'),
            ingredient('vegetables', 150, 'g', 'carb', 'carbs'),
            ingredient('turkey', 140, 'g', 'protein', 'protein'),
            ingredient('olive_oil', 1.5, 'tbsp', 'fat', 'fats')
          ]
        }
      ],
      vegetarian: [
        {
          id: 'breakfast',
          ingredients: [
            ingredient('oats', 90, 'g', 'carb', 'carbs'),
            ingredient('bananas', 1, 'count', 'carb', 'carbs'),
            ingredient('greek_yogurt', 200, 'g', 'protein', 'protein'),
            ingredient('peanut_butter', 1.5, 'tbsp', 'fat', 'fats')
          ]
        },
        {
          id: 'snack',
          ingredients: [
            ingredient('bagels', 1, 'count', 'carb', 'carbs'),
            ingredient('jam', 2, 'tbsp', 'carb', 'carbs'),
            ingredient('cottage_cheese', 170, 'g', 'protein', 'protein'),
            ingredient('peanut_butter', 1, 'tbsp', 'fat', 'fats')
          ]
        },
        {
          id: 'lunch',
          ingredients: [
            ingredient('rice', 130, 'g', 'carb', 'carbs'),
            ingredient('vegetables', 150, 'g', 'carb', 'carbs'),
            ingredient('tofu', 250, 'g', 'protein', 'protein'),
            ingredient('olive_oil', 0.5, 'tbsp', 'fat', 'fats')
          ]
        },
        {
          id: 'pre_training',
          ingredients: [
            ingredient('white_bread', 4, 'slice', 'carb', 'carbs'),
            ingredient('bananas', 1, 'count', 'carb', 'carbs'),
            ingredient('jam', 2, 'tbsp', 'carb', 'carbs'),
            ingredient('greek_yogurt', 120, 'g', 'protein', 'protein')
          ]
        },
        {
          id: 'dinner',
          ingredients: [
            ingredient('pasta', 120, 'g', 'carb', 'carbs'),
            ingredient('marinara', 200, 'g', 'carb', 'carbs'),
            ingredient('vegetables', 150, 'g', 'carb', 'carbs'),
            ingredient('tempeh', 180, 'g', 'protein', 'protein'),
            ingredient('olive_oil', 0.5, 'tbsp', 'fat', 'fats')
          ]
        }
      ],
      vegan: [
        {
          id: 'breakfast',
          ingredients: [
            ingredient('oats', 90, 'g', 'carb', 'carbs'),
            ingredient('bananas', 1, 'count', 'carb', 'carbs'),
            ingredient('soy_yogurt', 250, 'g', 'protein', 'protein'),
            ingredient('plant_protein', 25, 'g', 'protein', 'protein'),
            ingredient('peanut_butter', 1.5, 'tbsp', 'fat', 'fats')
          ]
        },
        {
          id: 'snack',
          ingredients: [
            ingredient('bagels', 1, 'count', 'carb', 'carbs'),
            ingredient('jam', 2, 'tbsp', 'carb', 'carbs'),
            ingredient('plant_protein', 30, 'g', 'protein', 'protein'),
            ingredient('peanut_butter', 1, 'tbsp', 'fat', 'fats')
          ]
        },
        {
          id: 'lunch',
          ingredients: [
            ingredient('rice', 130, 'g', 'carb', 'carbs'),
            ingredient('vegetables', 150, 'g', 'carb', 'carbs'),
            ingredient('tofu', 280, 'g', 'protein', 'protein'),
            ingredient('olive_oil', 0.5, 'tbsp', 'fat', 'fats')
          ]
        },
        {
          id: 'pre_training',
          ingredients: [
            ingredient('white_bread', 4, 'slice', 'carb', 'carbs'),
            ingredient('bananas', 1, 'count', 'carb', 'carbs'),
            ingredient('jam', 2, 'tbsp', 'carb', 'carbs'),
            ingredient('plant_protein', 20, 'g', 'protein', 'protein')
          ]
        },
        {
          id: 'dinner',
          ingredients: [
            ingredient('pasta', 120, 'g', 'carb', 'carbs'),
            ingredient('marinara', 200, 'g', 'carb', 'carbs'),
            ingredient('vegetables', 150, 'g', 'carb', 'carbs'),
            ingredient('tempeh', 200, 'g', 'protein', 'protein'),
            ingredient('olive_oil', 0.5, 'tbsp', 'fat', 'fats')
          ]
        }
      ]
    };

    const mealShares = {
      breakfast: { carbs: 0.22, protein: 0.25, fat: 0.22 },
      snack: { carbs: 0.14, protein: 0.15, fat: 0.12 },
      lunch: { carbs: 0.24, protein: 0.25, fat: 0.22 },
      pre_training: { carbs: 0.2, protein: 0.1, fat: 0.06 },
      dinner: { carbs: 0.2, protein: 0.25, fat: 0.38 }
    };

    const sharedDayVariations = [
      {},
      {
        'lunch:rice': { id: 'pasta', amount: 120 },
        'dinner:pasta': { id: 'rice', amount: 130 }
      },
      {
        'breakfast:oats': { id: 'cereal', amount: 90 },
        'breakfast:bananas': { id: 'berries', amount: 150, unit: 'g' },
        'snack:bagels': { id: 'granola', amount: 80, unit: 'g' },
        'snack:jam': { id: 'berries', amount: 120, unit: 'g' },
        'lunch:rice': { id: 'potatoes', amount: 450 },
        'pre_training:white_bread': { id: 'tortillas', amount: 3, unit: 'count' },
        'dinner:pasta': { id: 'rice', amount: 130 }
      },
      {
        'breakfast:oats': { id: 'granola', amount: 100 },
        'breakfast:bananas': { id: 'berries', amount: 150, unit: 'g' },
        'snack:bagels': { id: 'pita', amount: 2, unit: 'count' },
        'snack:jam': { id: 'berries', amount: 120, unit: 'g' },
        'snack:peanut_butter': { id: 'hummus', amount: 4 },
        'lunch:rice': { id: 'tortillas', amount: 4, unit: 'count' },
        'dinner:pasta': { id: 'potatoes', amount: 500 }
      },
      {
        'breakfast:bananas': { id: 'berries', amount: 150, unit: 'g' },
        'snack:bagels': { id: 'cereal', amount: 80, unit: 'g' },
        'snack:jam': { id: 'berries', amount: 120, unit: 'g' },
        'lunch:rice': { id: 'pasta', amount: 120 },
        'pre_training:white_bread': { id: 'pita', amount: 2, unit: 'count' },
        'dinner:pasta': { id: 'rice', amount: 130 }
      },
      {
        'breakfast:oats': { id: 'cereal', amount: 90 },
        'lunch:rice': { id: 'potatoes', amount: 450 },
        'pre_training:white_bread': { id: 'tortillas', amount: 3, unit: 'count' }
      },
      {
        'breakfast:oats': { id: 'granola', amount: 100 },
        'breakfast:bananas': { id: 'berries', amount: 150, unit: 'g' },
        'snack:bagels': { id: 'pita', amount: 2, unit: 'count' },
        'snack:jam': { id: 'berries', amount: 120, unit: 'g' },
        'snack:peanut_butter': { id: 'hummus', amount: 4 },
        'dinner:pasta': { id: 'potatoes', amount: 500 }
      }
    ];

    const proteinDayVariations = {
      omnivore: [
        {},
        {
          'breakfast:greek_yogurt': { id: 'cottage_cheese', amount: 170 },
          'snack:greek_yogurt': { id: 'cottage_cheese', amount: 170 },
          'lunch:chicken': { id: 'turkey', amount: 140 },
          'dinner:turkey': { id: 'chicken', amount: 120 }
        },
        {
          'lunch:chicken': { id: 'eggs', amount: 4, unit: 'count' },
          'dinner:turkey': { id: 'salmon', amount: 170 }
        },
        {
          'lunch:chicken': { id: 'turkey', amount: 140 },
          'dinner:turkey': { id: 'eggs', amount: 4, unit: 'count' }
        },
        {
          'lunch:chicken': { id: 'salmon', amount: 170 },
          'dinner:turkey': { id: 'chicken', amount: 120 }
        },
        {
          'snack:greek_yogurt': { id: 'cottage_cheese', amount: 170 },
          'lunch:chicken': { id: 'eggs', amount: 4, unit: 'count' },
          'dinner:turkey': { id: 'salmon', amount: 170 }
        },
        {
          'lunch:chicken': { id: 'salmon', amount: 170 },
          'dinner:turkey': { id: 'chicken', amount: 120 }
        }
      ],
      vegetarian: [
        {},
        {
          'breakfast:greek_yogurt': { id: 'cottage_cheese', amount: 200 },
          'snack:cottage_cheese': { id: 'greek_yogurt', amount: 150 },
          'lunch:tofu': { id: 'tempeh', amount: 180 },
          'dinner:tempeh': { id: 'tofu', amount: 250 }
        },
        {
          'lunch:tofu': { id: 'eggs', amount: 4, unit: 'count' },
          'dinner:tempeh': { id: 'black_beans', amount: 220 }
        },
        {
          'lunch:tofu': { id: 'black_beans', amount: 220 },
          'dinner:tempeh': { id: 'eggs', amount: 4, unit: 'count' }
        },
        {
          'lunch:tofu': { id: 'tempeh', amount: 180 },
          'dinner:tempeh': { id: 'tofu', amount: 250 }
        },
        {
          'lunch:tofu': { id: 'eggs', amount: 4, unit: 'count' },
          'dinner:tempeh': { id: 'black_beans', amount: 220 }
        },
        {
          'lunch:tofu': { id: 'tempeh', amount: 180 },
          'dinner:tempeh': { id: 'tofu', amount: 250 }
        }
      ],
      vegan: [
        {},
        {
          'lunch:tofu': { id: 'tempeh', amount: 200 },
          'dinner:tempeh': { id: 'tofu', amount: 280 }
        },
        {
          'lunch:tofu': { id: 'black_beans', amount: 220 },
          'dinner:tempeh': { id: 'lentils', amount: 180 }
        },
        {
          'lunch:tofu': { id: 'black_beans', amount: 220 },
          'dinner:tempeh': { id: 'lentils', amount: 180 }
        },
        {
          'lunch:tofu': { id: 'tempeh', amount: 200 },
          'dinner:tempeh': { id: 'tofu', amount: 280 }
        },
        {
          'lunch:tofu': { id: 'black_beans', amount: 220 },
          'dinner:tempeh': { id: 'lentils', amount: 180 }
        },
        {
          'lunch:tofu': { id: 'tempeh', amount: 200 },
          'dinner:tempeh': { id: 'tofu', amount: 280 }
        }
      ]
    };

    const groceryProducts = {
      oats: { capacity: 1191, packageType: 'canister' },
      bananas: { capacity: 1, packageType: 'banana' },
      greek_yogurt: { capacity: 907, packageType: 'tub' },
      soy_yogurt: { capacity: 680, packageType: 'tub' },
      peanut_butter: { capacity: 68, packageType: 'jar' },
      bagels: { capacity: 6, packageType: 'bag' },
      jam: { capacity: 25, packageType: 'jar' },
      cottage_cheese: { capacity: 680, packageType: 'tub' },
      plant_protein: { capacity: 920, packageType: 'tub' },
      rice: { capacity: 2268, packageType: 'bag' },
      vegetables: { capacity: 306, packageType: 'bag' },
      chicken: { capacity: 680, packageType: 'pack' },
      tofu: { capacity: 397, packageType: 'pack' },
      olive_oil: { capacity: 67, packageType: 'bottle' },
      white_bread: { capacity: 20, packageType: 'loaf' },
      pasta: { capacity: 454, packageType: 'box' },
      marinara: { capacity: 680, packageType: 'jar' },
      turkey: { capacity: 340, packageType: 'pack' },
      tempeh: { capacity: 227, packageType: 'pack' },
      cereal: { capacity: 462, packageType: 'box' },
      berries: { capacity: 1361, packageType: 'bag' },
      granola: { capacity: 700, packageType: 'bag' },
      potatoes: { capacity: 2268, packageType: 'bag' },
      tortillas: { capacity: 10, packageType: 'bag' },
      eggs: { capacity: 12, packageType: 'carton' },
      salmon: { capacity: 680, packageType: 'bag' },
      black_beans: { capacity: 255, packageType: 'can' },
      lentils: { capacity: 454, packageType: 'bag' },
      hummus: { capacity: 32, packageType: 'tub' },
      pita: { capacity: 6, packageType: 'bag' }
    };

    const getGrocerySearchUrl = (store, product) => {
      const safeStore = store || '';
      const normalizedStore = safeStore.toLowerCase().trim();
      const encodedProduct = encodeURIComponent(product);

      if (normalizedStore.includes('walmart')) {
        return `https://www.walmart.com/search?q=${encodedProduct}`;
      }
      if (normalizedStore.includes('target')) {
        return `https://www.target.com/s?searchTerm=${encodedProduct}`;
      }
      if (
        ['kroger', 'king soopers', 'city market', 'fred meyer', 'ralphs', 'smith', 'fry', 'qfc', 'dillons']
          .some((name) => normalizedStore.includes(name))
      ) {
        return `https://www.kroger.com/search?query=${encodedProduct}`;
      }
      if (normalizedStore.includes('whole foods')) {
        return `https://www.wholefoodsmarket.com/search?text=${encodedProduct}`;
      }
      if (normalizedStore.includes('costco')) {
        return `https://www.costco.com/s?keyword=${encodedProduct}`;
      }
      if (normalizedStore.includes('amazon')) {
        return `https://www.amazon.com/s?k=${encodedProduct}&i=amazonfresh`;
      }
      if (normalizedStore.includes('safeway')) {
        return `https://www.safeway.com/shop/search-results.html?q=${encodedProduct}`;
      }
      if (normalizedStore.includes('albertsons')) {
        return `https://www.albertsons.com/shop/search-results.html?q=${encodedProduct}`;
      }
      if (normalizedStore.includes('trader joe')) {
        return `https://www.traderjoes.com/home/search?q=${encodedProduct}`;
      }

      return `https://www.google.com/search?q=${encodeURIComponent(`${safeStore} ${product}`.trim())}`;
    };

    const getGroceryStoreUrl = (store) => {
      const normalizedStore = (store || '').toLowerCase().trim();

      if (normalizedStore.includes('walmart')) return 'https://www.walmart.com/cp/food/976759';
      if (normalizedStore.includes('target')) return 'https://www.target.com/c/grocery/-/N-5xt1a';
      if (
        ['kroger', 'king soopers', 'city market', 'fred meyer', 'ralphs', 'smith', 'fry', 'qfc', 'dillons']
          .some((name) => normalizedStore.includes(name))
      ) {
        return 'https://www.kroger.com/';
      }
      if (normalizedStore.includes('whole foods')) return 'https://www.wholefoodsmarket.com/';
      if (normalizedStore.includes('costco')) return 'https://www.costco.com/grocery-household.html';
      if (normalizedStore.includes('amazon')) return 'https://www.amazon.com/fmc/m/30003175';
      if (normalizedStore.includes('safeway')) return 'https://www.safeway.com/';
      if (normalizedStore.includes('albertsons')) return 'https://www.albertsons.com/';
      if (normalizedStore.includes('trader joe')) return 'https://www.traderjoes.com/home';

      return getGrocerySearchUrl(store, 'online grocery shopping');
    };

    const varyIngredient = (item, diet, dayIndex, mealId) => {
      const key = `${mealId}:${item.id}`;
      const sharedVariation = sharedDayVariations[dayIndex]?.[key] || {};
      const proteinVariation = proteinDayVariations[diet]?.[dayIndex]?.[key] || {};
      return { ...item, ...sharedVariation, ...proteinVariation };
    };

    const initialize = (root) => {
      if (root.dataset.nutritionInitialized === 'true') return;
      root.dataset.nutritionInitialized = 'true';

      const formElement = root.querySelector('form');
      const weightInput = root.querySelector('[data-weight]');
      const unitInputs = Array.from(root.querySelectorAll('[data-unit]'));
      const dietInput = root.querySelector('[data-diet]');
      const sportInput = root.querySelector('[data-sport]');
      const ageInput = root.querySelector('[data-age]');
      const groceryStoreInput = root.querySelector('[data-grocery-store]');
      const trainingMinutesInput = root.querySelector('[data-training-minutes]');
      const trainingCaloriesInput = root.querySelector('[data-training-calories]');
      const trainingIntensityInput = root.querySelector('[data-training-intensity]');
      const emailInput = root.querySelector('[data-email]');
      const unlockState = root.querySelector('[data-unlock-state]');
      const results = root.querySelector('[data-results]');
      const groceryCartButton = root.querySelector('[data-grocery-cart]');
      const groceryCartStatus = root.querySelector('[data-grocery-cart-status]');
      const copy = JSON.parse(root.querySelector('[data-nutrition-copy]').textContent);
      const storageKey = `nutrition-calculator:${window.location.pathname}:${root.dataset.sectionId}`;
      let lastUnit = unitInputs.find((input) => input.checked)?.value || 'lb';
      let groceryCartData = { store: '', items: [] };

      const getStoredState = () => {
        try {
          return JSON.parse(window.sessionStorage.getItem(storageKey) || 'null');
        } catch (error) {
          return null;
        }
      };

      const saveState = (submitted) => {
        const unit = unitInputs.find((input) => input.checked)?.value || 'lb';
        const state = {
          weight: Number(weightInput.value),
          unit,
          diet: dietInput.value,
          sport: sportInput.value,
          age: Number(ageInput.value),
          groceryStore: groceryStoreInput.value.trim(),
          trainingMinutes: Number(trainingMinutesInput.value) || 0,
          trainingCalories: Number(trainingCaloriesInput.value) || 0,
          trainingIntensity: trainingIntensityInput.value,
          email: emailInput.value,
          submitted,
          savedAt: Date.now()
        };
        window.sessionStorage.setItem(storageKey, JSON.stringify(state));
        return state;
      };

      const restoreState = (state) => {
        if (!state) return;
        if (Number.isFinite(state.weight)) weightInput.value = state.weight;
        const matchingUnit = unitInputs.find((input) => input.value === state.unit);
        if (matchingUnit) matchingUnit.checked = true;
        if (mealTemplates[state.diet]) dietInput.value = state.diet;
        if (copy.sports[state.sport]) sportInput.value = state.sport;
        if (Number.isFinite(state.age) && state.age >= 18 && state.age <= 100) {
          ageInput.value = state.age;
        }
        if (state.groceryStore) groceryStoreInput.value = state.groceryStore;
        if (Number.isFinite(state.trainingMinutes) && state.trainingMinutes > 0) {
          trainingMinutesInput.value = state.trainingMinutes;
        }
        if (Number.isFinite(state.trainingCalories) && state.trainingCalories > 0) {
          trainingCaloriesInput.value = state.trainingCalories;
        }
        if (copy.intensities[state.trainingIntensity]) {
          trainingIntensityInput.value = state.trainingIntensity;
        }
        if (state.email) emailInput.value = state.email;
        lastUnit = state.unit || lastUnit;
        updateWeightLimits(lastUnit);
      };

      const updateWeightLimits = (unit) => {
        if (unit === 'kg') {
          weightInput.min = '25';
          weightInput.max = '250';
        } else {
          weightInput.min = '55';
          weightInput.max = '550';
        }
      };

      const formatQuantity = (item, amount, grocery) => {
        let displayed;
        if (item.unit === 'g') {
          displayed = roundTo(amount, grocery ? 10 : 5);
        } else if (item.unit === 'count') {
          displayed = grocery ? Math.ceil(amount) : roundTo(amount, 0.5);
        } else if (item.unit === 'slice') {
          displayed = grocery ? Math.ceil(amount) : roundTo(amount, 1);
        } else {
          displayed = grocery ? Math.ceil(amount) : roundTo(amount, 0.5);
        }
        const unitLabel = item.unit === 'count' ? '' : copy.units[item.unit];
        let ingredientName = copy.ingredients[item.id];
        if (item.unit === 'count' && displayed === 1 && ingredientName.endsWith('s')) {
          ingredientName = ingredientName.slice(0, -1);
        }
        return `${displayed}${unitLabel ? ` ${unitLabel}` : ''} ${ingredientName}`;
      };

      const formatPackageQuantity = (item) => {
        const product = groceryProducts[item.id];
        const count = Math.max(1, Math.ceil(item.amount / product.capacity));
        const packageLabel = copy.packages[product.packageType][count === 1 ? 'one' : 'other'];
        return format(copy.grocery.buy_quantity, { count, package: packageLabel });
      };

      const buildPlan = (calculation, diet, groceryStore) => {
        const scales = {
          carb: calculation.carbTarget / 552.75,
          protein: calculation.protein / 148.5,
          fat: calculation.fat / 82.5
        };
        const grocery = new Map();
        const mealsContainer = root.querySelector('[data-meals]');
        mealsContainer.replaceChildren();
        root.querySelector('[data-grocery-store-summary]').textContent = format(
          copy.grocery.store_summary,
          { store: groceryStore }
        );

        copy.days.forEach((dayName, dayIndex) => {
          const dayCard = createElement('details', 'nutrition-calculator__day-card');
          const dayHeader = createElement('summary', 'nutrition-calculator__day-summary');
          const dayHeading = createElement('div', 'nutrition-calculator__day-heading');
          const dayToggle = createElement('span', 'nutrition-calculator__day-toggle');
          const dayChevron = createElement('span', 'nutrition-calculator__day-chevron', '⌄');
          const dayMeals = createElement('div', 'nutrition-calculator__day-meals');
          dayCard.open = dayIndex === 0;
          dayHeading.append(
            createElement('h3', '', dayName),
            createElement('p', '', format(copy.macro_line, {
              carbs: calculation.carbTarget,
              protein: calculation.protein,
              fat: calculation.fat
            }))
          );
          dayToggle.append(
            createElement('span', 'nutrition-calculator__day-toggle-open', copy.view_meals),
            createElement('span', 'nutrition-calculator__day-toggle-close', copy.hide_meals),
            dayChevron
          );
          dayChevron.setAttribute('aria-hidden', 'true');
          dayHeader.append(dayHeading, dayToggle);

          mealTemplates[diet].forEach((meal) => {
            const share = mealShares[meal.id];
            const card = createElement('article', 'nutrition-calculator__meal-card');
            const meta = createElement('div', 'nutrition-calculator__meal-meta');
            meta.append(
              createElement('h3', '', copy.meals[meal.id]),
              createElement('p', '', format(copy.macro_line, {
                carbs: Math.round(calculation.carbTarget * share.carbs),
                protein: Math.round(calculation.protein * share.protein),
                fat: Math.round(calculation.fat * share.fat)
              }))
            );

            const list = createElement('ul');
            meal.ingredients.forEach((baseItem) => {
              const item = varyIngredient(baseItem, diet, dayIndex, meal.id);
              const amount = item.amount * scales[item.scale];
              list.append(createElement('li', '', formatQuantity(item, amount, false)));
              const existing = grocery.get(item.id);
              if (existing) {
                existing.amount += amount;
              } else {
                grocery.set(item.id, { ...item, amount });
              }
            });
            card.append(meta, list);
            dayMeals.append(card);
          });
          dayCard.append(dayHeader, dayMeals);
          mealsContainer.append(dayCard);
        });

        ['carbs', 'protein', 'fats'].forEach((category) => {
          const list = root.querySelector(`[data-grocery-${category}]`);
          list.replaceChildren();
          Array.from(grocery.values())
            .filter((item) => item.category === category)
            .forEach((item) => {
              const productName = copy.products[item.id];
              const listItem = createElement('li', 'nutrition-calculator__grocery-product');
              const productLink = createElement('a', '', productName);
              productLink.href = getGrocerySearchUrl(groceryStore, productName);
              productLink.target = '_blank';
              productLink.rel = 'noopener noreferrer nofollow';
              productLink.setAttribute('aria-label', format(copy.grocery.search_label, {
                product: productName,
                store: groceryStore
              }));
              listItem.append(
                productLink,
                createElement('span', '', formatPackageQuantity(item))
              );
              list.append(listItem);
            });
        });

        groceryCartData = {
          store: groceryStore,
          items: Array.from(grocery.values())
        };
        const isInStoreOnly = groceryStore.toLowerCase().includes('trader joe');
        groceryCartButton.textContent = format(
          isInStoreOnly ? copy.grocery.list_button : copy.grocery.cart_button,
          { store: groceryStore }
        );
        groceryCartStatus.textContent = copy.grocery.cart_help;
      };

      const calculate = (state) => {
        const weightLb = state.unit === 'kg' ? state.weight * 2.2046226218 : state.weight;
        const carbLow = roundTo(weightLb * 3.2, 5);
        const carbHigh = roundTo(weightLb * 3.5, 5);
        const carbTarget = roundTo(weightLb * 3.35, 5);
        const protein = roundTo(weightLb * 0.9, 5);
        const fat = roundTo(weightLb * 0.5, 5);
        const calorieLow = Math.round((carbLow * 4) + (protein * 4) + (fat * 9));
        const calorieHigh = Math.round((carbHigh * 4) + (protein * 4) + (fat * 9));
        return {
          carbLow,
          carbHigh,
          carbTarget,
          protein,
          fat,
          calorieLow,
          calorieHigh
        };
      };

      const calculateTraining = (state) => {
        const minutes = Math.max(0, Number(state.trainingMinutes) || 0);
        const calories = Math.max(0, Number(state.trainingCalories) || 0);
        const intensity = copy.intensities[state.trainingIntensity] ? state.trainingIntensity : 'moderate';
        const hours = minutes / 60;
        let rateLow = 0;
        let rateHigh = 0;
        let carbLow = 0;
        let carbHigh = 0;

        if (minutes >= 45 && minutes < 60) {
          carbHigh = 20;
        } else if (minutes >= 60) {
          if (intensity === 'hard') {
            rateLow = 60;
            rateHigh = 120;
          } else if (minutes > 150) {
            rateLow = 60;
            rateHigh = 90;
          } else {
            rateLow = 30;
            rateHigh = 60;
          }
          carbLow = roundTo(hours * rateLow, 5);
          carbHigh = roundTo(hours * rateHigh, 5);
        }

        const carbTarget = (carbLow + carbHigh) / 2;
        return {
          minutes,
          calories,
          intensity,
          rateLow,
          rateHigh,
          carbLow,
          carbHigh,
          remainingCalories: Math.max(0, Math.round(calories - (carbTarget * 4)))
        };
      };

      const renderTraining = (state) => {
        const training = calculateTraining(state);
        const duration = root.querySelector('[data-training-duration]');
        const sessionNote = root.querySelector('[data-training-session-note]');
        const duringCarbs = root.querySelector('[data-training-carbs]');
        const foods = root.querySelector('[data-training-foods]');
        const addOn = root.querySelector('[data-training-add-on]');
        const remaining = root.querySelector('[data-training-remaining]');
        const recoveryProtein = root.querySelector('[data-recovery-protein]');
        const recoveryNote = root.querySelector('[data-recovery-note]');
        const sportLabel = copy.sports[state.sport] || copy.sports.other_endurance;

        if (training.minutes === 0) {
          duration.textContent = copy.training.no_session;
          sessionNote.textContent = copy.training.session_note;
          duringCarbs.textContent = copy.training.during_none;
          foods.textContent = copy.training.foods_short;
          recoveryProtein.textContent = copy.training.recovery_none;
          recoveryNote.textContent = copy.training.recovery_none_note;
        } else {
          duration.textContent = format(copy.training.minutes, { minutes: training.minutes });
          sessionNote.textContent = format(copy.training.sport_intensity_note, {
            sport: sportLabel,
            intensity: copy.intensities[training.intensity]
          });
          duringCarbs.textContent = training.carbHigh > 0
            ? training.rateHigh > 0
              ? format(copy.training.during_range, {
                low: training.carbLow,
                high: training.carbHigh,
                rateLow: training.rateLow,
                rateHigh: training.rateHigh
              })
              : copy.training.during_short
            : copy.training.during_none;
          foods.textContent = training.minutes >= 60
            ? `${copy.training.sport_foods[state.sport] || copy.training.sport_foods.other_endurance}${training.intensity === 'hard' ? ` ${copy.training.advanced_note}` : ''}`
            : copy.training.foods_short;

          const weightKg = state.unit === 'kg' ? state.weight : state.weight / 2.2046226218;
          const recoveryRate = state.age >= 60 ? 0.4 : 0.3;
          const recoveryTarget = roundTo(weightKg * recoveryRate, 5);
          recoveryProtein.textContent = format(copy.training.recovery_target, { grams: recoveryTarget });
          recoveryNote.textContent = state.age >= 60
            ? copy.training.recovery_older
            : copy.training.recovery_younger;
        }

        if (training.calories > 0) {
          addOn.textContent = format(copy.training.calorie_add_on, { calories: training.calories });
          remaining.textContent = format(copy.training.calorie_remaining, {
            calories: training.remainingCalories
          });
        } else {
          addOn.textContent = copy.training.calorie_missing;
          remaining.textContent = copy.training.session_note;
        }
      };

      const renderResults = (state, fromError) => {
        const calculation = calculate(state);
        root.querySelector('[data-summary]').textContent = format(copy.summary, {
          weight: state.weight,
          unit: state.unit,
          age: state.age,
          sport: copy.sports[state.sport] || copy.sports.other_endurance
        });
        root.querySelector('[data-carbs]').textContent = `${calculation.carbLow}–${calculation.carbHigh} ${copy.grams}`;
        root.querySelector('[data-carbs-note]').textContent = format(copy.recommended, {
          grams: calculation.carbTarget
        });
        root.querySelector('[data-protein]').textContent = `${calculation.protein} ${copy.grams}`;
        root.querySelector('[data-fat]').textContent = `${calculation.fat} ${copy.grams}`;
        root.querySelector('[data-calories]').textContent = `${calculation.calorieLow.toLocaleString()}–${calculation.calorieHigh.toLocaleString()}`;
        renderTraining(state);
        buildPlan(calculation, state.diet, state.groceryStore);
        results.hidden = false;
        if (fromError) {
          const errorBox = root.querySelector('.nutrition-calculator__form-errors');
          if (errorBox) errorBox.textContent = copy.already_subscribed;
        }
        results.focus({ preventScroll: true });
        results.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };

      unitInputs.forEach((input) => {
        input.addEventListener('change', () => {
          const nextUnit = input.value;
          const currentWeight = Number(weightInput.value);
          if (Number.isFinite(currentWeight) && nextUnit !== lastUnit) {
            weightInput.value = nextUnit === 'kg'
              ? Math.round((currentWeight / 2.2046226218) * 10) / 10
              : Math.round((currentWeight * 2.2046226218) * 10) / 10;
          }
          lastUnit = nextUnit;
          updateWeightLimits(nextUnit);
        });
      });

      formElement.addEventListener('submit', () => {
        if (formElement.checkValidity()) {
          saveState(true);
          weightInput.removeAttribute('name');
          dietInput.removeAttribute('name');
          sportInput.removeAttribute('name');
          ageInput.removeAttribute('name');
          groceryStoreInput.removeAttribute('name');
          trainingMinutesInput.removeAttribute('name');
          trainingCaloriesInput.removeAttribute('name');
          trainingIntensityInput.removeAttribute('name');
          unitInputs.forEach((input) => input.removeAttribute('name'));
        }
      });

      groceryCartButton.addEventListener('click', async () => {
        if (!groceryCartData.store || groceryCartData.items.length === 0) return;

        const groceryLines = groceryCartData.items.map((item) => {
          const productName = copy.products[item.id];
          return `${productName} — ${formatPackageQuantity(item)}`;
        });
        const groceryList = [
          copy.grocery.cart_title,
          groceryCartData.store,
          '',
          ...groceryLines
        ].join('\n');
        const clipboardPromise = navigator.clipboard?.writeText
          ? navigator.clipboard.writeText(groceryList)
          : Promise.reject(new Error('Clipboard unavailable'));

        window.open(
          getGroceryStoreUrl(groceryCartData.store),
          '_blank',
          'noopener,noreferrer'
        );

        try {
          await clipboardPromise;
          groceryCartStatus.textContent = format(copy.grocery.cart_copied, {
            store: groceryCartData.store
          });
        } catch (error) {
          groceryCartStatus.textContent = format(copy.grocery.cart_failed, {
            store: groceryCartData.store
          });
        }
      });

      root.querySelector('[data-print]').addEventListener('click', () => window.print());

      root.querySelector('[data-reset]').addEventListener('click', () => {
        window.sessionStorage.removeItem(storageKey);
        results.hidden = true;
        weightInput.focus();
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      const storedState = getStoredState();
      restoreState(storedState);
      const posted = unlockState?.dataset.posted === 'true';
      const hasErrors = unlockState?.dataset.errors === 'true';
      const isRecent = storedState && (Date.now() - storedState.savedAt) < 600000;
      if (
        storedState?.submitted
        && storedState.groceryStore
        && copy.sports[storedState.sport]
        && Number.isFinite(storedState.age)
        && storedState.age >= 18
        && storedState.age <= 100
        && isRecent
        && (posted || hasErrors)
      ) {
        renderResults(storedState, hasErrors && !posted);
      }
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-nutrition-calculator]').forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-premium-pdp"] && !Shopify.designMode) return;
  try {
    
  function initializeLaborDayCountdown(root = document) {
    const countdowns = root.querySelectorAll('[data-labor-day-countdown]:not([data-countdown-ready])');

    countdowns.forEach((countdown) => {
      countdown.dataset.countdownReady = 'true';
      const endAt = Date.parse(countdown.dataset.saleEnds || '');
      const hours = countdown.querySelector('[data-countdown-hours]');
      const minutes = countdown.querySelector('[data-countdown-minutes]');
      const seconds = countdown.querySelector('[data-countdown-seconds]');

      if (!Number.isFinite(endAt) || !hours || !minutes || !seconds) {
        countdown.hidden = true;
        return;
      }

      let intervalId;

      const updateCountdown = () => {
        const remaining = endAt - Date.now();

        if (remaining <= 0) {
          countdown.hidden = true;
          window.clearInterval(intervalId);
          return;
        }

        const totalSeconds = Math.floor(remaining / 1000);
        hours.textContent = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
        minutes.textContent = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
        seconds.textContent = String(totalSeconds % 60).padStart(2, '0');
      };

      updateCountdown();
      intervalId = window.setInterval(updateCountdown, 1000);
    });
  }

  initializeLaborDayCountdown();
  document.addEventListener('shopify:section:load', (event) => {
    initializeLaborDayCountdown(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["two-week-taper-planner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const format = (template, values) => Object.entries(values).reduce(
      (result, [key, value]) => result.split(`{${key}}`).join(String(value)),
      template
    );

    const roundToFive = (value) => Math.max(5, Math.round(value / 5) * 5);

    const initialize = (root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const form = root.querySelector('form');
      const results = root.querySelector('[data-results]');
      const unlockState = root.querySelector('[data-unlock-state]');
      const copy = JSON.parse(root.querySelector('[data-taper-copy]').textContent);
      const fields = {
        sport: root.querySelector('[data-sport]'),
        demand: root.querySelector('[data-demand]'),
        raceName: root.querySelector('[data-race-name]'),
        raceDate: root.querySelector('[data-race-date]'),
        weeklyHours: root.querySelector('[data-weekly-hours]'),
        sessions: root.querySelector('[data-sessions]'),
        longest: root.querySelector('[data-longest]'),
        hardSessions: root.querySelector('[data-hard-sessions]'),
        email: root.querySelector('[data-email]')
      };
      const storageKey = `taper-planner:${window.location.pathname}:${root.dataset.sectionId}`;

      const today = new Date();
      const dateFloor = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      const defaultRaceDate = new Date(dateFloor);
      defaultRaceDate.setDate(defaultRaceDate.getDate() + 14);
      fields.raceDate.min = dateFloor.toISOString().slice(0, 10);
      if (!fields.raceDate.value) fields.raceDate.value = defaultRaceDate.toISOString().slice(0, 10);

      const getState = (submitted = false) => ({
        sport: fields.sport.value,
        demand: fields.demand.value,
        raceName: fields.raceName.value.trim(),
        raceDate: fields.raceDate.value,
        weeklyHours: Number(fields.weeklyHours.value),
        sessions: Number(fields.sessions.value),
        longest: Number(fields.longest.value),
        hardSessions: Number(fields.hardSessions.value),
        email: fields.email.value,
        submitted,
        savedAt: Date.now()
      });

      const saveState = (state) => {
        try {
          window.sessionStorage.setItem(storageKey, JSON.stringify(state));
          return true;
        } catch (error) {
          return false;
        }
      };

      const readState = () => {
        try {
          return JSON.parse(window.sessionStorage.getItem(storageKey) || 'null');
        } catch (error) {
          return null;
        }
      };

      const restoreState = (state) => {
        if (!state) return;
        Object.entries(fields).forEach(([key, field]) => {
          if (state[key] !== undefined && state[key] !== null && state[key] !== '') field.value = state[key];
        });
      };

      const isValidState = (state) => Boolean(
        state
        && copy.sports[state.sport]
        && copy.demands[state.demand]
        && state.raceName
        && state.raceDate
        && Number.isFinite(state.weeklyHours)
        && state.weeklyHours >= 1
        && Number.isFinite(state.sessions)
        && state.sessions >= 2
        && Number.isFinite(state.longest)
        && state.longest >= 0.5
        && Number.isFinite(state.hardSessions)
        && state.hardSessions >= 0
      );

      const createElement = (tag, className, text) => {
        const element = document.createElement(tag);
        if (className) element.className = className;
        if (text !== undefined) element.textContent = text;
        return element;
      };

      const addDays = (date, amount) => {
        const next = new Date(date);
        next.setDate(next.getDate() + amount);
        return next;
      };

      const getNote = (sport, type) => {
        if (type === 'rest' || type === 'recovery' || type === 'shakeout') return copy.notes[type];
        const prefixMap = {
          road_run: 'road',
          trail_run: 'trail',
          cycling: 'cycling',
          triathlon: 'tri',
          hyrox: 'hyrox',
          ocr: 'ocr'
        };
        const family = type === 'quality' || type === 'primer' || type === 'tuneup'
          ? 'quality'
          : type === 'long'
            ? 'long'
            : type === 'race'
              ? 'race'
              : 'easy';
        return copy.notes[`${prefixMap[sport]}_${family}`];
      };

      const buildDurations = (offsets, types, targetMinutes, longestMinutes) => {
        const weights = {
          recovery: 0.6,
          easy: 1,
          quality: 1.15,
          primer: 0.7,
          long: 1.8,
          tuneup: 0.9,
          shakeout: 0.5
        };
        const totalWeight = offsets.reduce((sum, offset) => sum + weights[types[offset]], 0);
        const durations = {};
        offsets.forEach((offset) => {
          const type = types[offset];
          let duration = roundToFive(targetMinutes * weights[type] / totalWeight);
          if (type === 'long') duration = Math.min(duration, roundToFive(longestMinutes * 0.68));
          durations[offset] = duration;
        });
        return durations;
      };

      const generatePlan = (state) => {
        const raceDate = new Date(`${state.raceDate}T12:00:00`);
        const sessions = Math.max(2, Math.min(7, Math.round(state.sessions)));
        const hardSessions = Math.max(0, Math.min(4, Math.round(state.hardSessions)));
        const baselineMinutes = state.weeklyHours * 60;
        const demandFactors = {
          sprint: { weekOne: 0.7, weekTwo: 0.34 },
          middle: { weekOne: 0.74, weekTwo: 0.38 },
          long: { weekOne: 0.77, weekTwo: 0.42 },
          ultra: { weekOne: 0.8, weekTwo: 0.45 }
        };
        const weekOnePriority = [-7, -12, -10, -13, -9, -11, -8];
        const weekTwoPriority = [-5, -1, -3, -6, -4, -2];
        const weekOneOffsets = weekOnePriority.slice(0, sessions).sort((a, b) => a - b);
        const weekTwoCount = Math.max(2, Math.min(6, sessions - 1));
        const weekTwoOffsets = weekTwoPriority.slice(0, weekTwoCount).sort((a, b) => a - b);
        const selected = new Set([...weekOneOffsets, ...weekTwoOffsets]);
        const types = {
          '-13': 'easy',
          '-12': 'quality',
          '-11': 'recovery',
          '-10': 'easy',
          '-9': 'primer',
          '-8': 'easy',
          '-7': 'long',
          '-6': 'easy',
          '-5': 'tuneup',
          '-4': 'recovery',
          '-3': 'easy',
          '-2': 'recovery',
          '-1': 'shakeout',
          '0': 'race'
        };
        if (hardSessions === 0) {
          types['-12'] = 'easy';
          types['-9'] = 'easy';
          types['-5'] = 'easy';
        } else if (hardSessions === 1) {
          types['-9'] = 'easy';
        }
        const factors = demandFactors[state.demand];
        const weekOneDurations = buildDurations(
          weekOneOffsets,
          types,
          baselineMinutes * factors.weekOne,
          state.longest * 60
        );
        const weekTwoDurations = buildDurations(
          weekTwoOffsets,
          types,
          baselineMinutes * factors.weekTwo,
          state.longest * 60
        );
        const days = [];

        for (let offset = -13; offset <= 0; offset += 1) {
          const type = offset === 0 ? 'race' : selected.has(offset) ? types[offset] : 'rest';
          const duration = offset <= -7 ? weekOneDurations[offset] : weekTwoDurations[offset];
          days.push({
            offset,
            date: addDays(raceDate, offset),
            type,
            duration: type === 'rest' || type === 'race' ? null : duration,
            note: getNote(state.sport, type)
          });
        }

        return {
          days,
          weekOneMinutes: weekOneOffsets.reduce((sum, offset) => sum + weekOneDurations[offset], 0),
          weekTwoMinutes: weekTwoOffsets.reduce((sum, offset) => sum + weekTwoDurations[offset], 0)
        };
      };

      const renderPlan = (state) => {
        const plan = generatePlan(state);
        const raceDate = new Date(`${state.raceDate}T12:00:00`);
        const dateFormatter = new Intl.DateTimeFormat(undefined, { weekday: 'short', month: 'short', day: 'numeric' });
        const longDateFormatter = new Intl.DateTimeFormat(undefined, { month: 'long', day: 'numeric', year: 'numeric' });
        const hours = (minutes) => (Math.round((minutes / 60) * 10) / 10).toFixed(1);

        root.querySelector('[data-summary]').textContent = format(copy.summary, {
          race: state.raceName,
          date: longDateFormatter.format(raceDate),
          sport: copy.sports[state.sport],
          demand: copy.demands[state.demand]
        });
        root.querySelector('[data-baseline]').textContent = format(copy.hours_week, { hours: state.weeklyHours });
        root.querySelector('[data-week-one]').textContent = format(copy.hours_total, { hours: hours(plan.weekOneMinutes) });
        root.querySelector('[data-week-two]').textContent = format(copy.hours_total, { hours: hours(plan.weekTwoMinutes) });
        root.querySelector('[data-focus]').textContent = copy.focus[state.demand];

        const schedule = root.querySelector('[data-schedule]');
        schedule.replaceChildren();
        plan.days.forEach((day, index) => {
          const card = createElement('article', `taper-planner__day-card taper-planner__day-card--${day.type}`);
          const date = createElement('div', 'taper-planner__day-date');
          const content = createElement('div', 'taper-planner__day-content');
          const weekNumber = index < 7 ? 1 : 2;
          date.append(
            createElement('strong', '', dateFormatter.format(day.date)),
            createElement('span', '', format(copy.day_label, { day: index + 1 })),
            createElement('span', '', format(copy.week_label, { week: weekNumber }))
          );
          const durationText = day.type === 'race'
            ? copy.race_duration
            : day.duration
              ? format(copy.minutes, { minutes: day.duration })
              : copy.intensity.rest;
          content.append(
            createElement('h3', '', copy.activities[day.type]),
            createElement('p', 'taper-planner__session-meta', `${durationText} · ${copy.intensity[day.type]}`),
            createElement('p', '', day.note)
          );
          card.append(date, content);
          schedule.append(card);
        });

        results.hidden = false;
        const reveal = () => {
          results.focus({ preventScroll: true });
          results.scrollIntoView({ behavior: 'smooth', block: 'start' });
        };
        if (document.startViewTransition) {
          document.startViewTransition(reveal);
        } else {
          reveal();
        }
      };

      form.addEventListener('input', () => saveState(getState()));
      form.addEventListener('change', () => saveState(getState()));
      form.addEventListener('submit', (event) => {
        if (!form.checkValidity()) return;
        if (!saveState(getState(true))) {
          event.preventDefault();
          const errorBox = root.querySelector('[data-storage-error]');
          errorBox.hidden = false;
          errorBox.focus();
        }
      }, true);

      root.querySelector('[data-print]').addEventListener('click', () => window.print());
      root.querySelector('[data-reset]').addEventListener('click', () => {
        try {
          window.sessionStorage.removeItem(storageKey);
        } catch (error) {}
        const url = new URL(window.location.href);
        url.searchParams.delete('taper_posted');
        url.searchParams.delete('customer_posted');
        url.hash = '';
        window.history.replaceState(null, '', url);
        results.hidden = true;
        fields.sport.focus();
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      const storedState = readState();
      restoreState(storedState);
      const posted = unlockState && unlockState.dataset.posted === 'true';
      const hasErrors = unlockState && unlockState.dataset.errors === 'true';
      const parameters = new URLSearchParams(window.location.search);
      const returned = parameters.get('taper_posted') === 'true' || parameters.get('customer_posted') === 'true';
      const isRecent = storedState && (Date.now() - storedState.savedAt) < 86400000;
      if (storedState && isRecent && isValidState(storedState) && !hasErrors && (posted || returned || storedState.unlocked)) {
        saveState({ ...storedState, unlocked: true });
        renderPlan(storedState);
      }
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-taper-planner]').forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
